import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'app-image-picker',
  templateUrl: './image-picker.component.html',
  styleUrls: ['./image-picker.component.scss'],
})
export class ImagePickerComponent implements OnInit {
  isActionSheetOpen = false;
  @Output() photoCaptured = new EventEmitter<{ imageUri: string }>();
  public actionSheetButtons = [
    {
      text: 'Choose from gallery',
      icon: 'image-outline',
      handler: () => {
        this.onPickImageFromCamera('Gallery');
      },
    },
    {
      text: 'Take new picture',
      icon: 'camera-outline',
      handler: () => {
        this.onPickImageFromCamera('Camera');
      },
    },
  ];

  constructor() { }

  ngOnInit() { }

  openActionSheet() {
    this.setOpen(true);
  }

  setOpen(isOpen: boolean) {
    this.isActionSheetOpen = isOpen;
  }

  async onPickImageFromCamera(from: string) {
    if (!Capacitor.isPluginAvailable('Camera')) {
      return;
    }
    let source: any;
    if (from === 'Camera') {
      source = CameraSource.Camera;
    } else {
      source = CameraSource.Photos;
    }

    Camera.getPhoto({
      quality: 70,
      source,
      correctOrientation: true,
      resultType: CameraResultType.Base64,
      allowEditing: false,
    })
      .then((image) => {
        const imageUri = 'data:image/jpeg;base64, ' + image.base64String;
        this.photoCaptured.emit({ imageUri });
      })
      .catch((err) => { });
  }
}
